/* eslint-disable no-undef */
import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../../Context/CartContext';
import toast from "react-hot-toast";
import { Helmet } from 'react-helmet';
import "./FeaturedProducts.css";
export default function FeaturedProducts() {
    const [products, setProducts] = useState([]);
    const [isLoading, setIsloading] = useState(false);

    let navigate = useNavigate();

    let { addProduct, deleteItem} = useContext(CartContext);


    async function getProducts() {
        setIsloading(true)
        let { data } = await axios.get(`https://ecommerce.routemisr.com/api/v1/products`);
        setProducts(data.data);
        setIsloading(false)
    }

    function getProductId(id) {
        navigate(`/productDetails/${id}`); // Navigate with the product ID
    }

    useEffect(() => {
        getProducts();
    }, []);
    return (
        <>
            <Helmet>
                <title>Products</title>
            </Helmet>
            <div className="row my-5">
                {isLoading ? <div className='div-spin'><i className='fas fa-spinner fa-spin fa-3x text-main'></i></div> : <>
                    {products.map((product) => (
                    <div key={product._id} className="col-lg-2 col-md-3 col-sm-6">
                        <div className="product cursor-pointer px-2 py-3" onClick={() => getProductId(product._id)}>
                            <div className="image">
                                <img className="w-100 move" src={product.imageCover} alt="" />
                            <span
                                className="pro-icon"
                                onClick={(event) => {
                            event.stopPropagation();
                            addProduct(product._id);}}>
                            <i class="fa-solid fa-bag-shopping"></i>
                            </span>
                            </div>
                            <span className="text-main fw-bold font-sm">{product.category.name}</span>
                            <h3 className="h6">{product.title.split(" ").slice(0, 2).join(" ")}</h3>
                            <div className="d-flex justify-content-between">
                                <span className="text-muted">{product.price} EGP</span>
                                <span>
                                    <i className="fas fa-star rating-color"></i> 
                                    {product.ratingsAverage}
                                </span>
                            </div>
                            <button onClick={(event) => {
                                // event bubbling
                                event.stopPropagation();
                                addProduct(product._id)
                            }} className="btn bg-main text-white w-100">+ add</button>
                        </div>
                    </div>
                ))}
                </>}
            </div>
        </>
    );
}
